import {HistoryStep} from "./historyStep";
import {HistoryController} from "./historyController";
import {EventVerteiler} from "../../global/eventVerteiler";
import {arrayElementByKeyValue} from "../../global/arrayHelper";
import {IHistoryStep} from "./IHistoryStep";

export class HistoryStepColorChange extends HistoryStep implements IHistoryStep {
    private readonly colorCode;
    private readonly colorHexValueOld;
    private readonly colorHexValueNew;

    constructor(historyController: HistoryController, parameters) {
        if (typeof (parameters.type) !== "string") {
            parameters.type = "colorChange";
        }
        super(historyController, parameters);

        this.colorCode = parameters.colorCode;
        this.colorHexValueOld = parameters.colorHexValueOld;
        this.colorHexValueNew = parameters.colorHexValueNew;
    }

    undo() {
        EventVerteiler.broadcast(
            "colorChangedEvent",
            {
                colorCode: this.colorCode,
                colorHexValue: this.colorHexValueOld,
                sentFromHistoryController: true
            }
        );
        this.trySettingColorInController(this.colorHexValueOld);
        EventVerteiler.broadcast("broadcastUsedColorsEvent");
    }

    redo() {
        EventVerteiler.broadcast(
            "colorChangedEvent",
            {
                colorCode: this.colorCode,
                colorHexValue: this.colorHexValueNew,
                sentFromHistoryController: true
            }
        );
        this.trySettingColorInController(this.colorHexValueNew);
        EventVerteiler.broadcast("broadcastUsedColorsEvent");
    }

    private trySettingColorInController(colorHexValue) {
        try {
            this.setColorFromController_throwOnError(this.colorCode, colorHexValue);
        } catch (e) {
            this.controller.clearHistory();
        }
    }

    private setColorFromController_throwOnError(colorCode, colorHexValue) {
        const color = arrayElementByKeyValue(this.controller.colorCodes, "colorCode", colorCode);
        if (color === null) {
            throw ("colorNotFound");
        }
        color.colorHexValue = colorHexValue;
    }
}